<template>
  <div class="new_vip" >
    <div style="width: 100%;background-color: #FFFFFF;padding: 10px;position: absolute;top:0;height: 50px;z-index: 99;display: flex;align-items: center">
      <div style="display: flex;align-items: center;font-size: 20px;cursor:pointer;" @click="goback">
        <i class="el-icon-back"></i>
        <div style="margin-left: 10px">返 回</div>
      </div>
    </div>
    <div class="stat_box" v-if="$route.query.id==1" style="width: 100%;margin-top: 55px">
      <div class="stat_item2" style="width: 100%;">
        <div class="stat_item_title">
          已结算
          <span
            style="font-size: 14px;color: red;display: inline-block;margin-left: 20px"
          >总金额 = 积分商城结算 - 红包 - 商户分红</span
          >
        </div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">积分商品结算金额</div>
            <div class="part_value">
              {{ settlement_count.settlement_goods_money || 0 }}
              <span>元</span>
            </div>

          </div>
          <div class="part_line"></div>
          <div class="item_value_part" style="flex: 4">
            <div class="part_name">商户分红结算</div>
            <div class="part_value">
              {{ settlement_count.settlement_give_money || 0 }}
              <span>元</span>
            </div>

          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_name">用户红包结算</div>
            <div class="part_value">
              {{ settlement_count.settlement_bouns_money || 0 }}
              <span>元</span>
            </div>

          </div>
          <div class="part_line"></div>
          <div class="item_value_part">
            <div class="part_name">结算总金额</div>
            <div class="part_value">
              {{ settlement_count.settlement_money || 0 }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" style="margin-bottom: 10px;">
      <div class="options" v-if="$route.query.id==1">
        <el-form :model="params" label-width="90px">
          <!-- 3.13修改顶部筛选 -->
          <el-form-item label="时间筛选">
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              @change="timeDate($event,1)"
            >
            </el-date-picker>
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="timeSearch('search')"
            >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content" v-if="$route.query.id==1">
      <div class="table_box" >
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="setTableHeader"
          element-loading-text="正在查询..."
          border
        >
          <el-table-column type="selection" fixed></el-table-column>
          <el-table-column
            label="积分商品结算金额"
            prop="settlement_goods_money"
          ></el-table-column>
          <el-table-column label="商户分红结算" prop="settlement_give_money"></el-table-column>
          <el-table-column
            label="用户红包结算"
            prop="settlement_bonus_money"
            align="center"
          ></el-table-column>
          <el-table-column
            label="结算总金额"
            prop="settlement_money"
            align="center"
          ></el-table-column>
          <el-table-column
            label="结算时间"
            prop="create_time"
            align="center"
          ></el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="goto_Info(scope.row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="page">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  settlement_bonus,
  settlement_detail_list,
  settlement_logs,
  settlement_logs_count,
  settlement_detail_count
} from "@/api/integralMall";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      settlement_date:[],
      settlement_count:{},
      settlement_list:[],
      form:{},
      tableLoading:false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      params: {
        create_time_s: "",
        create_time_e: ""
      },
      tableData: [],
      dateValue: [],
      settle: {},
      page: 1,
      total: 0,
    }
  },
  mounted() {
    if(this.$route.query.id==1){
      this.get_data();
    }
  },
  methods:{
    goback(){
      this.$router.go(-1)
    },
    goto_Info(item){
      this.$router.push({
        path:'settlement_logs',
        query:{
          key:this.$route.query.key,
          id:2,
          settlement:'',
          settlement_id:item.id
        }
      })
    },
    async get_data() {
      const res = await settlement_logs({
        app_id: this.app_id,
        page: this.page,
        ...this.params
      });
      this.tableData = res.data.data;
      this.total = res.data.total;
      this.getsettlement_logs_count()
    },
    async getsettlement_logs_count(){
      const res = await settlement_logs_count({
        app_id:this.app_id,
        ...this.params
      })
      this.settlement_count = res.data
    },
    timeDate(val,key) {
      if(key==1){
        if(val){
          this.params.create_time_e = val[1];
          this.params.create_time_s = val[0];
        }else {
          this.params.create_time_e = ''
          this.params.create_time_s = ''
        }
      }
      if(key==2){
        if(val){
          this.params.settlement_time_e = val[1];
          this.params.settlement_time_s = val[0];
        }else {
          this.params.settlement_time_e = ''
          this.params.settlement_time_s = ''
        }
      }
      this.get_data()
    },
    timeSearch(val) {
      console.log(val)
      if(this.$route.query.id==1){
        this.get_data();
      }
    },
    handleCurrentChange(val) {
      console.log(val)
      this.page = val
      if(this.$route.query.id == 1){
        this.get_data()
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 50px 0 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 15px;
    // display: flex;
    // flex-direction: column;
    .options {
      .options_item {
        width: 25%;
        display: inline-block;
      }
      // .options_input{
      //   width: 230px;
      // }
      .input_box_small {
        width: 240px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 115px;
        margin-right: 8px;
      }
      .inline_title {
        margin-left: 24px;
        margin-right: 12px;
      }
      .emp_search {
        margin-left: 15px;
      }
    }
    .table_box {
      // flex: 1;
      margin-top: 10px;
    }
    .page {
      margin-top: 15px;
    }
  }
  .dialog_option {
    margin-bottom: 15px;
    .options_item {
      display: inline-block;
      margin-left: 18px;
      .item_label {
        margin-right: 10px;
      }
      .select_box {
        width: 140px;
      }
    }
    .button_line {
      margin-top: 15px;
      padding-left: 18px;
    }
  }
  .align_c {
    text-align: center;
  }
  .stat_box {
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    .stat_item:first-child {
      margin: 0;
    }
    .stat_item {
      width: 9%;
      background: #fff;
      height: 100px;
    }
    .stat_item2 {
      width: 45.5%;
      background: #fff;
      height: 150px;
    }
    .stat_item3 {
      width: 45%;
      background: #fff;
      height: 100px;
    }
    .stat_item_title {
      height: 50px;
      line-height: 29px;
      padding: 10px;
      font-size: 18px;
      border-bottom: 1px solid #f5f5f5;
    }
    .stat_item_value {
      padding: 0px 10px;
      padding-top: 8px;
      font-size: 21px;
      line-height: 21px;
      color: #666;
      display: flex;
      span {
        font-size: 14px;
      }
    }
    .stat_item_value2 {
      text-align: center;
      //line-height: 24px;
      color: #666;
      display: flex;
      .item_value_part {
        flex: 5;
        padding-top: 6px;
        .part_name {
          height: 30px;
          line-height: 30px;
        }
        .part_value {
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 60px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value3 {
      color: #666;
      display: flex;
      .item_value_part {
        padding-left: 10px;
        flex: 1;
        padding-top: 7px;
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value4 {
      color: #666;
      display: flex;
      text-align: center;
      .item_value_part {
        flex: 1;
        padding-top: 12px;
        .part_title4 {
          font-size: 13px;
          margin-bottom: 5px;
        }
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
  }
}
.date_picker_delete {
  width: 140px;
}
::v-deep .el-popover,
.el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}
a{
  color: #00a4ff;
}
a:hover{
  cursor:pointer;
  border-bottom: 1px solid #00F;
}
</style>